<template>
    <q-page>
        <div class="q-pa-md">
            <div class="text-h4">Usuarios</div>
            <q-table dense :pagination="{rowsPerPage: 10}" :rows-per-page-options="[0]" virtual-scroll flat bordered
                :rows="usuarios" separator="cell">
                <template v-slot:header>
                    <q-tr class="bg-dark text-white">
                        <q-th key="Nombre" align="left">Nombre</q-th>
                        <q-th key="Usuario" align="left">Usuario</q-th>
                        <q-th key="TipoUsuario" align="left">Tipo</q-th>
                        <q-th auto-width key="Activo" align="left">Activo</q-th>
                        <q-th auto-width key="Activo" align="left">Solo Lectura</q-th>
                        <q-th auto-width key="Actions" align="center">
                            <q-btn icon="add" color="dark" size="sm" padding="5px 5px" @click="editUsuario(0)" />
                        </q-th>
                    </q-tr>
                </template>
                <template v-slot:body="props">
                    <q-tr>
                        <q-td>
                            {{ props.row.Nombre }}
                        </q-td>
                        <q-td>
                            {{ props.row.Usuario }}
                        </q-td>
                        <q-td>
                            {{ props.row.TipoUsuario<2?'Administrador':'Usuario' }} </q-td>
                            <q-td>
                                <q-icon name="circle" class="text-positive" size="sm" v-if="props.row.Activo" />
                                <q-icon name="circle" class="text-negative" size="sm" v-if="!props.row.Activo" />
                            </q-td>
                            <q-td>
                                <q-icon name="circle" class="text-positive" size="sm" v-if="props.row.SoloLectura" />
                                <q-icon name="circle" class="text-grey" size="sm" v-if="!props.row.SoloLectura" />
                            </q-td>
                                <q-td>
                                    <q-btn-group>
                                        <q-btn title="Editar" icon="edit" color="secondary" size="sm" padding="5px 5px"
                                            @click="editUsuario(props.row.IdUsuario)" />
                                        <q-btn title="Permisos" v-if="props.row.TipoUsuario==2" icon="account_tree"
                                            color="primary" size="sm" padding="5px 5px"
                                            @click="editPermisos(props.row.IdUsuario)" />
                                        <q-btn title="Bitácora" icon="library_books" color="accent" size="sm" padding="5px 5px"
                                            @click="iniBitacora(props.row.IdUsuario)" />
                                        <q-btn title="Reestablecer Contraseña" icon="lock" color="dark" size="sm"
                                            padding="5px 5px" @click="resetPwdConfirm(props.row.IdUsuario)" />
                                        <!--<q-btn icon="delete" color="negative" size="sm" padding="5px 5px" @click="showUsuario(props.row.IdUsuario)"/>-->
                                    </q-btn-group>
                                </q-td>
                    </q-tr>
                </template>
            </q-table>
        </div>
    </q-page>

    <q-dialog v-model="edit" persistent>
        <q-card style="width: 700px; max-width: 80vw;">
            <q-toolbar class="bg-dark text-white">
                <q-toolbar-title>Usuario</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup />
            </q-toolbar>
            <q-card-section>
                <q-form class="q-gutter-md" @submit.prevent="saveUsuario">
                    <q-input outlined dense v-model="usuario.Nombre" label="Nombre" :rules="rules" />
                    <q-input outlined dense v-model="usuario.Correo" label="Correo" :rules="rules" />
                    <q-input outlined dense :disable="usuario.IdUsuario!=0" v-model="usuario.Usuario" label="Usuario"
                        :rules="rules" />
                    <q-select outlined option-value="IdTipo" option-label="Descripcion" dense
                        v-model="usuario.TipoUsuario" :options="tiposUsuario" option-disable="inactive" emit-value
                        map-options label="Tipo" />
                        <q-toggle dense v-model="usuario.Activo" label="Activo" left-label />
                        <q-toggle dense v-model="usuario.SoloLectura" label="Solo Lectura" left-label />

                    <div>
                        <div class="q-pa-md q-gutter-sm float-right">
                            <q-btn color="secondary" text-color="white" label="Cerrar" @click="edit=false" />
                            <q-btn color="primary" label="Guardar" type="submit" />
                        </div>
                    </div>
                </q-form>
            </q-card-section>
        </q-card>
    </q-dialog>

    <q-dialog v-model="per" persistent full-width>
        <q-card style="width: 700px; max-width: 80vw;">
            <q-toolbar class="bg-dark text-white">
                <q-toolbar-title>Permisos: {{usuario.Nombre}}</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup />
            </q-toolbar>
            <q-card-section>
                <q-form class="q-gutter-md" @submit.prevent="savePermisos">

                    <q-tree class="col-12 col-sm-6" :nodes="adscripciones" node-key="id" tick-strategy="strict"
                        v-model:ticked="permisos" v-model:expanded="expanded" default-expand-all />

                    <div>
                        <div class="q-pa-md q-gutter-sm float-right">
                            <q-btn color="secondary" text-color="white" label="Cerrar" @click="per=false" />
                            <q-btn color="primary" label="Guardar" type="submit" />
                        </div>
                    </div>
                </q-form>
            </q-card-section>
        </q-card>
    </q-dialog>

    <q-dialog v-model="pwd" persistent >
        <q-card style="width: 700px; max-width: 80vw;">
            <q-toolbar class="bg-dark text-white">
                <q-toolbar-title>Reestablecer Contraseña</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup />
            </q-toolbar>
            <q-card-section>
                <q-form class="q-gutter-md" @submit.prevent="resetPwd">
                    <p>
                        Está seguro de reestablecer la contraseña a {{usuario.Nombre}}?
                    </p>
                    <div>
                        <div class="q-pa-md q-gutter-sm float-right">
                            <q-btn color="secondary" text-color="white" label="Cerrar" @click="pwd=false" />
                            <q-btn color="primary" label="Generar Contraseña" type="submit" />
                        </div>
                    </div>
                </q-form>
            </q-card-section>
        </q-card>
    </q-dialog>

      <!------------------------------------------------------Bitácora------------------------------------------------------>
        <q-dialog v-model="bBitacora" persistent>
            <q-card style="width: 700px; max-width: 80vw;">
                <q-toolbar class="bg-dark text-white">
                    <q-toolbar-title>Bitácora</q-toolbar-title>
                    <q-btn flat round dense icon="close" v-close-popup />
                </q-toolbar>
                <q-card-section>
                    <q-form class="q-gutter-md" @submit.prevent="rptBitacora">
                        <div class="row">
                            <div class="col col-md-12">
                                <q-input class="m-3" outlined dense v-model="fechaBitacora.FechaIni" label="Fecha Inicial"
                                    mask="date" :rules="['date']">
                                    <template v-slot:append>
                                        <q-icon name="event" class="cursor-pointer">
                                            <q-popup-proxy ref="qDateProxy" cover transition-show="scale"
                                                transition-hide="scale">
                                                <q-date v-model="fechaBitacora.FechaIni" :locale="myLocale">
                                                    <div class="row items-center justify-end">
                                                        <q-btn v-close-popup label="Close" color="primary" flat />
                                                    </div>
                                                </q-date>
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>
                            </div>
                            <div class="col col-md-12">
                                <q-input class="m-3" outlined dense v-model="fechaBitacora.FechaFin"
                                    label="Fecha Final" mask="date" :rules="['date']">
                                    <template v-slot:append>
                                        <q-icon name="event" class="cursor-pointer">
                                            <q-popup-proxy ref="qDateProxy" cover transition-show="scale"
                                                transition-hide="scale">
                                                <q-date v-model="fechaBitacora.FechaFin" :locale="myLocale">
                                                    <div class="row items-center justify-end">
                                                        <q-btn v-close-popup label="Close" color="primary" flat />
                                                    </div>
                                                </q-date>
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>
                            </div>
                        </div>
                        <div>
                            <div class="q-pa-md q-gutter-sm float-right">
                                <q-btn color="secondary" text-color="white" label="Cerrar"
                                    @click="bRestaurar = false" />
                                <q-btn color="primary" label="Generar" type="submit" />
                            </div>
                        </div>
                    </q-form>
                </q-card-section>
            </q-card>
        </q-dialog>
        <!---------------------------------------------------------------------------------------------------------------->
</template>
<script>

import http from "@/services/http"

export default {
    data: () => ({
        idUsuario: 0,
        usuarios: [],
        usuario: {},
        tiposUsuario: [{ IdTipo: 1, Descripcion: "Administrador" }, { IdTipo: 2, Descripcion: "Usuario" }],
        edit: false,
        del: false,
        per: false,
        pwd: false,
        rules: [v => !!v || 'Campo obligatorio',],

        adscripciones: [],
        permisos: [],
        expanded: ['001110000000000'],

        bBitacora:false,
        fechaBitacora: {},
    }),
    methods: {
        async initialize() {
            this.usuarios = await http.get('configuracion/usuarios');
        },
        
        async iniBitacora(id) {
             this.fechaBitacora = { FechaIni: this.getFecha(new Date()), FechaFin: this.getFecha(new Date()) }
            this.bBitacora = true
            this.idUsuario=id
        },
        rptBitacora() {
            this.bBitacora = false
            window.open(this.getUrlRpt() + 'Reportes/GeneraReporte.ashx?obj={"Rpt":6,"IdUsuario":"' + this.idUsuario +'", "Fecha":"' + this.fechaBitacora.FechaIni + '","FechaFin":"' + this.fechaBitacora.FechaFin + '"}', '_blank');
        },
         async editUsuario(id) {
            if (id === 0) {
                this.usuario = { Activo: true, SoloLectura:false, Correo: "", IdUsuario: 0, Nombre: "", TipoUsuario: 2, Usuario: "" };
            }
            else {
                this.usuario = await http.get(`configuracion/usuarios/usuario/${id}`)
            }
            this.edit = true
        },
        async saveUsuario() {
            await http.post('configuracion/usuarios/usuario', this.usuario)
            this.edit = false
            this.initialize()
        },
        async editPermisos(id) {
            this.permisos = []
            this.idUsuario = id;
            this.usuario = await http.get(`configuracion/usuarios/usuario/${id}`)
            this.adscripciones = await http.get('configuracion/usuarios/adscripciones')
            this.permisos = await http.get(`configuracion/usuarios/permisos/${id}`)
            this.per = true
        },
        async savePermisos() {
            await http.post('configuracion/usuarios/permisos', { id: this.idUsuario, permisos: this.permisos })
            this.per = false
            this.initialize()
        },
        async resetPwdConfirm(id) {
            this.idUsuario = id;
            this.usuario = await http.get(`configuracion/usuarios/usuario/${id}`)
            this.pwd = true;
        },
        async resetPwd() {
            await http.post('configuracion/usuarios/resetpwd', { id: this.idUsuario })
            this.pwd = false
            this.initialize()
        },
        getFecha(fecha) {
            return fecha.getFullYear() + '/' + String(fecha.getMonth() + 1).padStart(2, '0') + '/' + String(fecha.getDate()).padStart(2, '0');
        },
         getUrlRpt() {
            return (process.env.NODE_ENV !== 'production') ? 'http://localhost:60870/' : (location.hostname.includes('a1cy9') ? 'http://a1cy9/sicope/api/' : 'http://presupuesto.haciendachiapas.gob.mx/sicope/api/')
        },
    },
    created() {
        this.initialize()
    },
}
</script>